export const environment = {
  production: true,
  buildId: '2762620769018831',
  configFile: 'config.json',
};
